import LiferayService from "./liferay";

export const deleteBatch = (url, dataToDelete = []) => {
    console.log("ENTER ")
    return new Promise(async (resolve, reject) => {
        try {
            await
            dataToDelete.map(async (item) => {
                console.log("START DELETING ", item)
                console.log("URL ", `${url}/${item}`)
                await LiferayService.delete(`${url}/${item}`);
                console.log("END DELETE ", item)
            })
            resolve(true);
        } catch (error) {
            reject(error);
        }
    });
};

export const executeBatchDelete = (nomObject, ids) => {
    const route = `o/c/${nomObject}`
    deleteBatch(route, ids)
}
